import { Box } from '@mui/material';
import AddRole from './add-role/AddRole';

const RolesPage: React.FC = () => {
  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: 'background.default',
    }}>
      <AddRole />
    </Box>
  );
};

export default RolesPage;
